import { render, staticRenderFns } from "./star.vue?vue&type=template&id=327aeda8&scoped=true&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&id=327aeda8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327aeda8",
  null
  
)

export default component.exports